import React from "react";

// Define the data object interface
interface ContactData {
  name: string;
  company: string;
  contact: [
    {
      email: string;
      phone_number: string;
    },
  ];
  address: [
    {
      address: string;
      address_title: string;
      city: string;
      state: string;
      zip: string;
    },
  ];
  tags: string[];
  notes: string;
  website_link: string;
  account_number: string;
  vendorDiscount: {
    value: number;
    unit: string;
  };
}

interface ContactDetailsProps {
  data: ContactData;
}

const CreateVendorMobile: React.FC<ContactDetailsProps> = (props) => {
  const {
    name,
    company,
    contact,
    address,
    tags,
    notes,
    website_link,
    account_number,
    vendorDiscount,
  } = props.data;

  const formatAddress = (addressObj: any) => {
    const parts = [
      addressObj.address,
      addressObj.city,
      addressObj.state,
      addressObj.zip,
    ].filter(Boolean); // Filter out empty, null, or undefined values

    return parts.join(", ");
  };

  return (
    <div className="my-6">
      <p className="font-semibold text-lg text-black-primary text-left px-4">
        Vendor Details
      </p>
      {/* Contact Details Section */}
      <div className="p-4">
        <h2 className="text-sm font-semibold text-black-secondary mb-4">
          Contact Details
        </h2>

        <div className="mb-4">
          <div className="flex py-2 ">
            <span className="w-1/3 text-sm text-black-secondary font-medium">
              Company
            </span>
            <span className="w-2/3 text-black-primary">{company}</span>
          </div>
          <div className="flex py-2 ">
            <span className="w-1/3 text-sm text-black-secondary font-medium">
              Name
            </span>
            <span className="w-2/3 text-black-primary">{name}</span>
          </div>

          <div className="flex py-2 ">
            <span className="w-1/3 text-sm text-black-secondary font-medium">
              Web Link
            </span>
            <span className="w-2/3 text-black-primary break-words cursor-pointer">
              <a href={website_link} target="_blank" rel="noopener noreferrer">
                {website_link}
              </a>
            </span>
          </div>

          <div className="flex py-2 ">
            <span className="w-1/3 text-sm text-black-secondary font-medium">
              Acc no#
            </span>
            <span className="w-2/3 text-black-primary">{account_number}</span>
          </div>

          <div className="flex py-2 ">
            <span className="w-1/3 text-sm text-black-secondary font-medium">
              Phone
            </span>
            <div className="w-2/3">
              {contact?.map((item, index) => (
                <div
                  key={`vendor-${item.phone_number}-${index}`}
                  className=" text-black-primary mb-1"
                >
                  {item.phone_number}
                </div>
              ))}
            </div>
          </div>

          <div className="flex py-2 ">
            <span className="w-1/3 text-sm text-black-secondary font-medium">
              Email
            </span>
            <div className="w-2/3">
              {contact?.map((item, index) => (
                <div
                  key={`vendor-${item.email}-${index}`}
                  className=" text-black-primary mb-1"
                >
                  {item.email}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <hr />
      {/* Address Section */}
      <div className="p-4 ">
        <h2 className="text-sm font-semibold text-black-secondary mb-4">
          Address
        </h2>

        {address?.map((item, index) => (
          <div
            key={`vendor-${item.address_title}-${index}`}
            className="border border-customGrey-border2 rounded-lg p-4 mb-4"
          >
            <p className="text-black-primary mb-2">{item.address_title}</p>
            <p className="text-black-primary">
              {formatAddress(item)}
              {/* {item.address}, {item.city}, {item.state}, {item.zip} */}
            </p>
          </div>
        ))}
      </div>

      {/* Tags Section */}
      <div className="p-4 border-t border-gray-200">
        <h2 className="text-sm font-semibold text-black-secondary mb-4">
          Tags
        </h2>

        <div className="flex flex-wrap gap-2">
          {tags?.map((tag, index) => (
            <div
              key={`vendor-${tag}-${index}`}
              className="flex items-center bg-customGreen-bg text-customGreen-text rounded-full px-3 py-1"
            >
              <span>{tag}</span>
            </div>
          ))}
          {tags?.length === 0 && (
            <div className="flex items-center justify-center w-full">
              <span>No tags</span>
            </div>
          )}
        </div>
        <div className="flex items-center py-2 mt-2 ">
          <span className="w-1/3 text-sm text-black-secondary font-medium">
            Vendor Discount
          </span>
          <span className="w-2/3 text-black-primary">
            {vendorDiscount?.value || 0}%
          </span>
        </div>
      </div>

      {/* Internal Notes Section */}
      <div className="p-4 border-t border-gray-200">
        <h2 className="text-sm font-semibold text-black-secondary mb-4">
          Internal Notes
        </h2>

        <p className="text-black-primary">{notes}</p>
      </div>
    </div>
  );
};

export default CreateVendorMobile;
